export default "__VITE_ASSET__3642b347__"